import { BOARD_CLASSES_BY_TYPE } from './BoardClassByType';
import { BoardID, createBoardID } from 'BoardID';
import { BoardType, BoardTypes, Units } from 'Types';

import { isDev } from 'utils/utils';

export function getCtor<T extends BoardType>(
  type: T
): typeof BOARD_CLASSES_BY_TYPE[T] {
  return BOARD_CLASSES_BY_TYPE[type];
}

export function createBoard<T extends new (...args: any[]) => InstanceType<T>>(
  ctor: T,
  id: BoardID,
  name: string,
  params: ConstructorParameters<T>[2],
  units: Units
): InstanceType<T> {
  return new ctor(id, name, params, units);
}

export function createAnonymousBoard<
  T extends new (...args: any[]) => InstanceType<T>
>(ctor: T, params: ConstructorParameters<T>[2], units: Units): InstanceType<T> {
  return createBoard(ctor, createBoardID(), '', params, units);
}

export function getBoardTypes(): Array<BoardType> {
  return BoardTypes.filter((className) => {
    const isDevOnly = getCtor(className).isDevOnly;
    return !isDevOnly || isDev();
  });
}
